/* eslint-disable */

export function menuInit() {
  menuMobile();
}

function menuMobile() {
  if ($('.toggle-mobile-menu').length > 0) {
    $('.toggle-mobile-menu').on('click', function() {
      if($('header nav').hasClass('menu-mobile-open')){
        $('header nav').removeClass('menu-mobile-open');
        $('.toggle-mobile-menu .close').hide();
        $('.toggle-mobile-menu .open').show();
      }
      else {
        $('header nav').addClass('menu-mobile-open');
        $('.toggle-mobile-menu .close').show();
        $('.toggle-mobile-menu .open').hide();
      }
    });
  }
}
